import { Controller, useFormContext } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { Paper, Stack, TextField, Autocomplete, Button, Typography } from '@mui/material';
import { OpenInNew } from '@mui/icons-material';
import { useGetAllSchoolShiftByLicenseQuery } from 'services/SchoolShift/hooks/useQuery';
import { ISchoolShiftSimpleProps } from 'services/SchoolShift/types';
import { SchoolClassFormData } from 'services/SchoolClass/schemas';
import { useMemo } from 'react';

export function BasicDataCard() {
  const navigate = useNavigate();  
  const { control, formState: { errors } } = useFormContext<SchoolClassFormData>();

  const { data: shiftList = [], isLoading: isLoadingShifts } = useGetAllSchoolShiftByLicenseQuery(
    { pageNumber: 1, pageSize: 500 }
  );

  const shiftsMap = useMemo(() => {
    const map = new Map<number, ISchoolShiftSimpleProps>();
    
    shiftList.forEach((shift: ISchoolShiftSimpleProps) => {
      if (shift.id !== undefined) {
        map.set(shift.id, shift);
      }
    });
    
    return map;
  }, [shiftList]);

  return (
    <Paper elevation={0} sx={{ p: 4, borderRadius: 3, border: '1px solid', borderColor: 'divider', bgcolor: 'background.paper' }}>
      <Typography variant="subtitle1" fontWeight="bold" color="text.primary" sx={{ mb: 3 }}>
        Dados Básicos
      </Typography>

      <Stack spacing={3} direction={{ xs: 'column', md: 'row' }}>
        <Controller
          name="name"
          control={control}
          render={({ field }) => (
            <TextField
              {...field}
              fullWidth
              label="Nome da Turma"
              error={!!errors.name}
              helperText={errors.name?.message}
              sx={{ '& .MuiInputBase-root': { bgcolor: 'background.default' } }}
            />
          )}
        />

        <Controller
          name="shiftId"
          control={control}
          render={({ field }) => (
            <Autocomplete
              fullWidth
              options={shiftList}
              loading={isLoadingShifts}
              loadingText="Carregando turnos..."
              getOptionLabel={(option: ISchoolShiftSimpleProps) => option.name || ''}
              value={field.value ? shiftsMap.get(field.value) || null : null}
              onChange={(_, data) => field.onChange(data ? data.id : null)}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Turno"
                  error={!!errors.shiftId}
                  helperText={errors.shiftId?.message}
                  sx={{ '& .MuiInputBase-root': { bgcolor: 'background.default' } }}
                />
              )}
            />
          )}
        />
      </Stack>

      <Button
        size="small"
        endIcon={<OpenInNew />}
        sx={{ mt: 2, textTransform: 'none' }}
        onClick={() => navigate('/app/turn')}
      >
        Gerenciar Turnos Cadastrados
      </Button>
    </Paper>
  );
}